import React from 'react';
import PropTypes from 'prop-types';

import { Text, WithTooltip } from 'components/common/Elements/Elements';

import { cutTextforToltip } from 'utils/common';

const CutIfToltip = ({ data = 'NA', length }) => {
  if (data.length > length) {
    return (
      <WithTooltip text={data}>
        <div>
          <Text>{cutTextforToltip(data, length - 3)}</Text>
        </div>
      </WithTooltip>
    );
  }
  return data;
};

CutIfToltip.propTypes = {
  data: PropTypes.string,
  length: PropTypes.number
};

export default CutIfToltip;
